module.exports = __webpack_public_path__ + "media/images/home/ic_comment-0bd17960c39d7127a4ef5ed8ce12fb8a.svg";